import React from 'react'
import { IAgentSettingsData, useAgentBusinessDetails, useAgentContactDetails } from '../api/agent-settings'
import { Loader, MainContainer, PageContainer } from '@reapit/elements'
import { IUserProfileData, useUserProfile } from '../api/user-profile'

export type OrganizationContactContextValue = Partial<
  IAgentSettingsData['contactDetails'] & IAgentSettingsData['details'] & IUserProfileData
>

const OrganizationContactContext = React.createContext<OrganizationContactContextValue | null>(null)

export const useOrganizationContact = () => React.useContext(OrganizationContactContext)

export const OrganizationContactProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { data: contactData, loading: loadContactData } = useAgentContactDetails()
  const { data: businessData, loading: loadBusinessData } = useAgentBusinessDetails()
  const { data: userProfile, loading: loadUserProfile } = useUserProfile()

  if (loadContactData || loadBusinessData || loadUserProfile)
    return (
      <MainContainer hasGreyBackground>
        <PageContainer>
          <Loader fullPage />
        </PageContainer>
      </MainContainer>
    )
  const data =
    !contactData && !businessData && !userProfile
      ? null
      : { ...(contactData ?? {}), ...(businessData ?? {}), ...(userProfile ?? {}) }

  return <OrganizationContactContext.Provider value={data}>{children}</OrganizationContactContext.Provider>
}
